<template>
  <div>
    <!-- 二次认领 v-if="!['03', '04', '05'].includes(businessType)" -->
    <vxe-toolbar>
      <template v-slot:buttons>
        <!--  财务驳回财务审核通过，一次认领二次认领都需要可更改
        非代付情况：未生成收款单，或者收款单撤回（删除）可更改一次数据，二次认领随时可更改
        代付情况：财务审核通过可更改二次认领，不可更改一次认领，驳回不可更改二次认领，可更改一次认领，审批中二次认领，一次认领都不可更改
        代付情况下，还没有进行财务审核，二次认领的按钮不能点，一次认领可以
       -->
        <vxe-button
          :disabled="isDisabled"
          @click="insertRow(-1)"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('receivablesManage.button.add') }}</vxe-button
        >
        <vxe-button
          :disabled="isDisabled"
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('receivablesManage.button.delete') }}</vxe-button
        >
        <vxe-button
          v-if="isClaim"
          :disabled="isDisabled"
          @click="chkOrderSettle()"
          type="primary"
          icon="el-icon-files"
          class="vxe-btn-primary"
          >保存</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      show-footer
      :footer-method="footerMethod"
      max-height="300px"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import dataBaseAPI from '@/api/dataBase';
  // import API from '@/api/capitalCenter/receivablesManage';
  export default {
    name: 'receivablesClaimInfo',
    props: [
      'contractCategory',
      'departmentList',
      'secondUnClaimAmountList', // 二次未认领金额
      'formData',
      'firstUnClaimedAmount',
      'businessType',
      'secondClaimData1', // 单独给物业、仓储、监管单
    ],
    components: {
      // SearchTable,
      // inputNumberAd,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      getBusinessCategory() {
        const map = {
          '01': '01',
          '02': '02',
          '03': '05',
          '04': '03',
          '05': '06',
        };
        return map[this.businessType];
      },
      // 是否为物贸
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.businessGroup);
      },
      getProjectBusinessCategory() {
        if (this.userInfo.businessGroup == '城矿') {
          return '01';
        } else if (this.userInfo.businessGroup == '物贸') {
          return '02';
        } else if (this.userInfo.businessGroup == '国贸') {
          return '02';
        } else if (this.userInfo.businessGroup == '多式联运') {
          return '03';
        } else if (this.userInfo.businessGroup == '园区') {
          return '04';
        } else {
          return '';
        }
      },
      // 二次认领
      column() {
        return [
          { type: 'checkbox', width: 50, fixed: 'left' },
          {
            // 序号
            type: 'seq',
            width: 90,
            title: this.$t('receivablesManage.receivablesClaimInfo.seq'),
            fixed: 'left',
          },
          {
            // 一次认领行项目号
            field: 'firstClaimId',
            width: 150,
            title: '一次认领行项目号',
            fixed: 'left',
            editRender: {
              name: 'ElSelect',
              options: this.firstClaimNoList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.chooseFirstClaimId },
            },
          },
          {
            // 客户
            field: 'customerName',
            title: this.$t('receivablesManage.receivablesClaimInfo.customerNo'),
            width: 150,
          },
          {
            // 收款类别
            field: 'receivedType',
            title: this.$t('receivablesManage.receivablesClaimInfo.receivedType'),
            width: 150,
            editRender: {
              name: 'ElSelect',
              options: this.receivedTypeOptions,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: (obj) => this.updateCol(obj.row, 'receivedType') },
            },
          },
          {
            // 部门
            field: 'claimDepartmentNo',
            title: this.$t('receivablesManage.receivablesClaimInfo.secClaimDepartmentNo'),
            width: 150,
          },
          {
            // 部门描述
            field: 'claimDepartmentName',
            title: this.$t('receivablesManage.receivablesClaimInfo.claimDepartmentName'),
            width: 150,
          },
          ...(this.businessType == '01'
            ? [
                {
                  // 收款细类
                  field: 'receivedDetailType',
                  title: this.$t('receivablesManage.receivablesClaimInfo.receivedDetailType'),
                  width: 150,
                  editRender: {
                    name: 'ElSelect',
                    options: this.$baseRequest.getDictListMapByType('receivedDetailType'),
                    props: {
                      clearable: true,
                      filterable: true,
                    },
                  },
                },
              ]
            : []),

          {
            //项目
            field: 'projectCode',
            title: '项目',
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.projectName}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="commonProject"
                      isMultiple={true}
                      currentValue={row['projectName']}
                      checkRowKeys={[row['projectCode']]}
                      parseExtendMap={true}
                      extraData={{
                        businessCategory: this.getProjectBusinessCategory,
                        projectCompanyNo: this.userInfo.companyCode,
                        projectDepartmentNo: this.userInfo.departmentCode,
                      }}
                      onInput={(val) => this.chooseTable(val, row, 'projectCode')}
                    ></search-table>,
                  ];
                  // if (this.isWuMaoAccount) {
                  //   return [
                  //     <SearchTable
                  //       searchType="limitProjectListWumao"
                  //       isMultiple={true}
                  //       extraData={{
                  //         projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
                  //         applyCompanyNo: this.userInfo.companyCode,
                  //         applyCompanyName: this.userInfo.companyName,
                  //         dataGroup: 'wm',
                  //       }}
                  //       currentValue={row['projectName']}
                  //       checkRowKeys={[row['projectInitiationNo']]}
                  //       onInput={(val) => this.chooseTable(val, row, 'projectCode')}
                  //     ></SearchTable>,
                  //   ];
                  // } else {
                  //   return [
                  //     <search-table
                  //       searchType="projectInitiation"
                  //       isMultiple={true}
                  //       currentValue={row['projectName']}
                  //       checkRowKeys={[row['projectCode']]}
                  //       extraData={{
                  //         projectInitiationStatusList: ['PIS04', 'PIS05'],
                  //       }}
                  //       onInput={(val) => this.chooseTable(val, row, 'projectCode')}
                  //     ></search-table>,
                  //   ];
                  // }
                },
              },
            },
          },
          ...(this.newContractCategory == 'sales'
            ? [
                {
                  // 销售合同号
                  field: 'salesOrderNo',
                  title: this.$t('receivablesManage.receivablesClaimInfo.salesOrderNo'),
                  width: 150,
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.salesOrderNo}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="commonContract"
                          isMultiple={true}
                          currentValue={row['salesOrderNo']}
                          checkRowKeys={[row['salesOrderNo']]}
                          isNeedCustomerName={true}
                          extraData={{
                            businessCategory: this.getBusinessCategory,
                            contractCompanyNo: this.userInfo.companyCode,
                            contractDepartmentNo: this.userInfo.departmentCode,
                            customerNo: row.customerNo,
                            contractStatus: 'ZT03',
                            contractCategory: 'sales',
                            contractBusinessDepartment: row.claimDepartmentNo,
                            kind: 'line',
                          }}
                          parseExtendMap={true}
                          onInput={(val) => this.chooseTable(val, row, 'salesOrderNo')}
                        ></search-table>,
                      ];
                    },
                  },
                },
                /* ...(this.receiptClaimMode == 'L'
                  ? [
                      {
                        // 提单号，只有销售合同有
                        field: 'ladingNo',
                        title: this.$t('receivablesManage.receivablesClaimInfo.ladingNo'),
                        width: 150,
                        editRender: { name: 'ElInput', props: { clearable: true } },
                        slots: {
                          default: ({ row }) => {
                            return [<span>{row.ladingNo}</span>];
                          },
                          edit: ({ row }) => {
                            return [
                              row.salesOrderNo ? (
                                <search-table
                                  searchType="salesLading"
                                  isMultiple={true}
                                  currentValue={row['ladingNo']}
                                  checkRowKeys={[row['ladingNo']]}
                                  extraData={{
                                    contractNo: row.salesOrderNo,
                                    ladingStatus: 'TDZT03',
                                  }}
                                  onInput={(val) => this.chooseTable(val, row, 'ladingNo')}
                                ></search-table>
                              ) : (
                                row.ladingNo
                              ),
                            ];
                          },
                        },
                      },
                    ]
                  : []), */
              ]
            : [
                {
                  // 采购合同号
                  field: 'purchaseOrderNo',
                  title: this.$t('receivablesManage.receivablesClaimInfo.purchaseOrderNo'),
                  width: 150,
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.purchaseOrderNo}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="commonContract"
                          isMultiple={true}
                          currentValue={row['purchaseOrderNo']}
                          checkRowKeys={[row['purchaseOrderNo']]}
                          isNeedCustomerName={true}
                          extraData={{
                            businessCategory: this.getBusinessCategory,
                            contractCompanyNo: this.userInfo.companyCode,
                            contractDepartmentNo: this.userInfo.departmentCode,
                            supplierNo: row.customerNo,
                            contractStatus: 'ZT03',
                            contractCategory: 'purchase',
                            contractBusinessDepartment: row.claimDepartmentNo,
                            kind: 'line',
                          }}
                          parseExtendMap={true}
                          onInput={(val) => this.chooseTable(val, row, 'purchaseOrderNo')}
                        ></search-table>,
                      ];
                    },
                  },
                },
              ]),
          {
            //结算单
            field: 'settlementNo',
            title: '结算单',
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.settlementNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="receivableSettlement"
                      isMultiple={true}
                      currentValue={row['settlementNo']}
                      checkRowKeys={[row['settlementNo']]}
                      disabled={this.newContractCategory == 'sales' && !row.salesOrderNo}
                      extraData={{
                        settlementStatus: '04',
                        customerNo: row.customerNo,
                        contractCompanyNo: this.userInfo.companyCode,
                        contractDepartmentNo: this.userInfo.departmentCode,
                        ...(this.newContractCategory == 'sales'
                          ? {
                              contractNo: row.salesOrderNo,
                            }
                          : {}),
                      }}
                      onInput={(val) => this.chooseTable(val, row, 'settlementNo')}
                    ></search-table>,
                  ];
                },
              },
            },
          },
          /* {
            // 业务订单
            field: 'contractNo',
            title: this.$t('receivablesManage.receivablesClaimInfo.contractNo'),
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.contractNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  row.salesOrderNo || row.purchaseOrderNo ? (
                    <search-table
                      searchType="businessOrder"
                      isMultiple={true}
                      currentValue={row['orderNo']}
                      checkRowKeys={[row['orderNo']]}
                      extraData={{
                        contractNo: row.salesOrderNo ? row.salesOrderNo : row.purchaseOrderNo,
                      }}
                      onInput={(val) => this.chooseTable(val, row, 'contractNo')}
                    ></search-table>
                  ) : (
                    row.contractNo
                  ),
                ];
              },
            },
          },
          {
            // 形式发票金额
            field: 'originProformaInvoiceAmount',
            title:
              this.$t('receivablesManage.receivablesClaimInfo.originProformaInvoiceAmount') +
              '(' +
              this.formData.receiveInfoCurrencyName +
              ')',
            width: 150,
            ...(this.formData.originProformaInvoiceAmount
              ? {
                  editRender: {
                    name: 'ElInput',
                    props: {
                      clearable: true,
                    },
                  },
                }
              : {}),
            // 认领详情-形式发票金额存在时，形式发票金额手动填写，收款金额根据形式发票金额自动计算
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originProformaInvoiceAmount)}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originProformaInvoiceAmount}
                    max={this.firstUnClaimedAmount['originProformaInvoiceAmount']}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'originProformaInvoiceAmount')}
                    onChange={(val) =>
                      this.verifyAmount(val, row, 'originProformaInvoiceAmount', true)
                    }
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 形式发票金额（本币）
            field: 'localProformaInvoiceAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.localProformaInvoiceAmount'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.localProformaInvoiceAmount)}
                  </span>,
                ];
              },
            },
          }, */
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.originReceiveMoneyAmount'),
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            // 认领详情-形式发票金额不存在时，形式发票金额禁止填写，收款金额手动填写
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveMoneyAmount)}</span>,
                ];
              },
              ...(!this.formData.originProformaInvoiceAmount
                ? {
                    edit: ({ row }) => {
                      return [
                        <input-number-ad
                          value={row.originReceiveMoneyAmount}
                          max={this.firstUnClaimedAmount['originReceiveMoneyAmount']}
                          min={0}
                          onInput={(val) => this.chooseTable(val, row, 'originReceiveMoneyAmount')}
                          onChange={(val) =>
                            this.verifyAmount(val, row, 'originReceiveMoneyAmount', true)
                          }
                        ></input-number-ad>,
                      ];
                    },
                  }
                : {}),
            },
          },
          {
            // 收款金额（本币）
            field: 'localReceiveMoneyAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.localReceiveMoneyAmount'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.localReceiveMoneyAmount)}</span>,
                ];
              },
            },
          },
          {
            // 备注
            field: 'remark',
            title: '备注',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            // slots: {
            //   default: ({ row }) => {
            //     return [<span>{row.remark}</span>];
            //   },
            // },
          },
          /* {
            // 国内银行扣费
            field: 'originDomesticBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.originDomesticBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originDomesticBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
          {
            // 国内银行扣费（本币）
            field: 'localDomesticBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.localDomesticBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.localDomesticBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
          {
            // 国外银行扣费
            field: 'originForeignBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.originForeignBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originForeignBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
          {
            // 国外银行扣费（本币）
            field: 'localForeignBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.localForeignBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.localForeignBankDeductFee)}</span>,
                ];
              },
            },
          }, */
        ];
      },
      rules() {
        return {
          firstClaimId: [
            { required: true, message: '请选择一次认领行项目号', trigger: ['blur', 'change'] },
          ],
          ...(this.newContractCategory == 'sales'
            ? {
                salesOrderNo: [
                  {
                    required: true,
                    message: this.$t('receivablesManage.placeholder.salesOrderNoPlaceholder'),
                    trigger: ['blur', 'change'],
                  },
                ],
              }
            : {
                purchaseOrderNo: [
                  {
                    required: true,
                    message: this.$t('receivablesManage.placeholder.purchaseOrderNoPlaceholder'),
                    trigger: ['blur', 'change'],
                  },
                ],
              }),
          originReceiveMoneyAmount: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.originReceiveMoneyAmountPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          receivedDetailType: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.receivedDetailTypePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          // settlementNo: [
          //   {
          //     required: true,
          //     message: '结算单必填',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
        };
      },
      isDisabled() {
        return (
          (this.formData.isAnotherPay == true || this.formData.isAnotherPay == 'Y') &&
          this.formData.financeAuditStatus != '002'
        );
      },
      /* isProject() {
        return this.formData.receiveMethod === 'SK07';
      }, */
    },
    data() {
      return {
        isClaim: false,
        tableData: [], // 表格数据
        del: [],
        secondUnClaimAmount: {}, // 二次未认领金额
        newContractCategory: this.contractCategory,
        addRowObj: {
          firstClaimId: null,
          customerNo: null,
          customerName: null,
          receivedType: null,
          claimDepartmentNo: null,
          claimDepartmentName: null,
          salesOrderNo: null,
          ladingNo: null,
          purchaseOrderNo: null,
          contractNo: null,
          originProformaInvoiceAmount: 0,
          localProformaInvoiceAmount: 0,
          originReceiveMoneyAmount: 0,
          localReceiveMoneyAmount: 0,
          originDomesticBankDeductFee: 0,
          localDomesticBankDeductFee: 0,
          originForeignBankDeductFee: 0,
          localForeignBankDeductFee: 0,
          projectName: null,
          projectCode: null,
          receivedDetailType: null,
        },
        receiptClaimMode: null, // 判断收款认领模式 C-合同,L-提单
        firstClaimNoList: [], // 一次认领行项目列表
        projectCode: null,
        projectName: null,
        receivedTypeOptions: [],
      };
    },
    mounted() {
      this.isClaim = this.$route.name == 'claim' ? true : false;
    },
    watch: {
      /* isProject() {
        this.loadProject();
      }, */
      businessType: {
        handler(val) {
          // 园区仓储
          if (val == '03') {
            this.newContractCategory = 'sales';
          }
          this.computedReceivedTypeOptions(val);
        },
        immediate: true,
      },
      contractCategory: {
        handler(val) {
          if (this.businessType != '03') {
            this.newContractCategory = val;
          }
        },
      },
    },
    methods: {
      updateCol(row, type) {
        console.log(row.receivedType, '===?');
        if (type == 'receivedType') {
          if (this.businessType != '03') {
            if (['RT07', 'RT15', 'RT16', '08', '14', '15'].indexOf(row.receivedType) != -1) {
              row['customerNo'] = null;
              row['customerName'] = null;
              this.newContractCategory = 'purchase';
            } else {
              row['claimPartnerNo'] = null;
              row['claimPartnerName'] = null;
              this.newContractCategory = 'sales';
            }
          } else {
            this.newContractCategory = 'sales';
          }

          this.addRowObj.receivedType = row.receivedType;
        }
      },
      computedReceivedTypeOptions(businessType) {
        console.log('当前类型', businessType, this.dictListMap.parkReceivedType);
        /**
       * { label: '贸易', value: '01' },
              { label: '多式联运', value: '02' },
              { label: '园区仓储', value: '03' },
              { label: '园区物业', value: '04' },
              { label: '监管单', value: '05' },
       */
        if (businessType == '01') {
          let options = this.$baseRequest.getDictListMapByType('receivedType');
          //【ID1002141】海宁收款认领增加类别  收款一次认领类别增加“预收账款”
          if (this.sysConfigFlag == 'Y') {
            options.push({ label: '预收账款', value: 'RT17' });
          }
          console.log(options);
          //【ID1000806】本部收款认领收款类别增加“供应商保证金”，认领到供应商保证金类型的不可关联客户，只可认领到“供应商或者合作伙伴类型”的合作伙伴
          if (
            this.sysConfigFlag == 'N' &&
            !this.addRowObj.customerNo &&
            this.formData.payerType != 'HZHB01'
          ) {
            options.push({ label: '供应商保证金', value: 'RT18' });
          }
          this.receivedTypeOptions = options;
        } else if (businessType == '02') {
          console.log('多式联运下拉框');
          this.receivedTypeOptions = this.dictListMap.multimodalTransportReceivedType;
        } else if (businessType == '03') {
          console.log('园区仓储下拉框');
          this.receivedTypeOptions = [
            ...this.dictListMap.warehouseContractGuizhongLoadExpenseList,
            ...this.dictListMap.warehouseExpenseName,
          ];
          console.log(JSON.stringify(this.receivedTypeOptions), '--->');
        } else if (businessType == '04') {
          console.log('园区物业下拉框');
          this.receivedTypeOptions = this.dictListMap.property_settlement_cost;
        } else if (businessType == '05') {
          console.log('监管单下拉框');
          this.receivedTypeOptions = this.dictListMap.parkReceivedType;
        } else {
          console.log(businessType, '等待开发中');
          this.receivedTypeOptions = [];
        }
      },
      loadProject() {
        this.$axios
          .post('/financial/creditLetter/getProjectInfoByClCode', { clCode: this.formData.clCode })
          .then((res) => {
            this.projectName = res.data.data.projectName;
            this.projectCode = res.data.data.projectCode;
            if (this.tableData?.length > 0) {
              this.tableData.forEach((item) => {
                item.projectName = this.projectName;
                item.projectCode = this.projectCode;
              });
            }
          });
      },
      // 表格新增一行
      insertRow(row) {
        // console.log("row",row,this.addRowObj)
        if (this.projectName && this.projectCode) {
          this.addRowObj.projectName = this.projectName;
          this.addRowObj.projectCode = this.projectCode;
        }

        let record = {
          ...this.addRowObj,
          customerName: null,
          customerNo: null,
          receivedType: null,
        };
        this.$refs.table.validate().then(() => {
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
            if (this.businessType != '03') {
              if (['RT07', 'RT15', 'RT16', '08', '14', '15'].indexOf(row.receivedType) != -1) {
                row['customerNo'] = null;
                row['customerName'] = null;
                this.newContractCategory = 'purchase';
              } else {
                row['claimPartnerNo'] = null;
                row['claimPartnerName'] = null;
              }
            } else {
              this.newContractCategory = 'sales';
            }
          });
        });
      },
      // 表格删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.tips('noData', 'error');
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.del.push(item.id);
              }
            });
            this.$refs.table.removeSelecteds();
            this.tips('deleteSuccess', 'success');
          })
          .catch(() => {
            this.tips('cancelled', 'info');
          });
      },
      async chkOrderSettle() {
        // 判断是否已关联结算批次
        let params = {
          associationType: '6',
          associationNoList: [this.formData.registerNo],
        };
        let res = await this.$baseRequest.chkOrderSettle(params);
        if (res) {
          if (res.code == 0) {
            this.handleSave();
          } else if (res.code == 10000) {
            this.$confirmAction('确认更改？', '该单据已关联结算批次，是否确认更改？')
              .then(() => {
                this.handleSave();
              })
              .catch(() => {
                this.$message({
                  showClose: true,
                  type: 'info',
                  message: this.$t('message.cancelled'),
                });
              });
          }
        }
      },
      // 保存二次认领
      async handleSave() {
        // 需选择待拆分数据才能进行保存
        if (!this.formData.id) {
          return this.tips('onlyOneSelectData', 'error');
        }
        let departmentNos = [];
        if (this.departmentList.length > 0) {
          departmentNos = this.departmentList.map((item) => {
            return item.value;
          });
        }
        // 基本信息
        let params = {
          id: this.formData.id,
          departmentNos: departmentNos,
        };
        // 二次认领
        let secondClaimInfo = await this.exportChildData();
        console.log(secondClaimInfo, '????');
        if (secondClaimInfo) {
          params = {
            ...params,
            ...secondClaimInfo,
            businessType: this.businessType,
          };
          this.$emit('secondClaim', params);
        }
      },
      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      footerMethod({ columns, data }) {
        // 一次认领表尾合计
        let returnAmountProps = [
          'originProformaInvoiceAmount',
          'localProformaInvoiceAmount',
          'originReceiveMoneyAmount',
          'localReceiveMoneyAmount',
          'originDomesticBankDeductFee',
          'localDomesticBankDeductFee',
          'originForeignBankDeductFee',
          'localForeignBankDeductFee',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return this.$t('receivablesManage.receivablesClaimInfo.hasClaim');
            }
            if (returnAmountProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return this.$t('receivablesManage.receivablesClaimInfo.noClaim');
            }
            if (returnAmountProps.includes(column.property)) {
              let minuend = this.firstUnClaimedAmount[column.property];
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(
                this.$cal.calCommon(minuend, subtrahend, '-')
              );
            }
            return null;
          }),
        ];
      },
      filterTotalAmount(firstClaimId) {
        // 筛选总金额
        if (firstClaimId) {
          return this.secondUnClaimAmountList.find((item) => item.firstClaimId == firstClaimId);
        }
        return {};
      },

      // 金额校验，已认领金额不能大于总金额，当已认领金额等于总金额时，其他金额倒扣
      verifyAmount(val, row, prop, isChange) {
        let returnAmountProps = [
          'localReceiveMoneyAmount',
          'originDomesticBankDeductFee',
          'localDomesticBankDeductFee',
          'originForeignBankDeductFee',
          'localForeignBankDeductFee',
        ];
        let idx;
        if (prop == 'originProformaInvoiceAmount') {
          // 存在形式发票金额
          idx = 7;
          returnAmountProps = [
            'localProformaInvoiceAmount',
            'originReceiveMoneyAmount',
            ...returnAmountProps,
          ];
        } else {
          // 不存在形式发票金额，以收款金额为准
          idx = 9;
          returnAmountProps = [...returnAmountProps];
        }
        let sum = this.$refs.table.getTableData().footerData[0][idx];
        if (isChange) {
          // 二次认领金额不能超过一次认领金额
          let tableData = this.$refs.table.getTableData().fullData;
          let sameFirstSum = 0; //相同一次认领行的合计
          tableData = tableData.filter((item) => item.firstClaimId == row.firstClaimId);
          tableData.map((item) => {
            sameFirstSum = this.$cal.calCommon(sameFirstSum, item[prop], '+');
          });
          let firstNum = this.firstClaimNoList.find((item) => item.id == row.firstClaimId)[prop];
          if (sameFirstSum > firstNum) {
            this.$message({
              showClose: true,
              message: '二次认领合计金额不能超过对应一次认领的金额',
              type: 'error',
            });
            let resetNum = this.$cal.calCommon(
              firstNum,
              this.$cal.calCommon(sameFirstSum, row[prop], '-'),
              '-'
            );
            if (prop == 'originProformaInvoiceAmount') {
              row.originProformaInvoiceAmount = resetNum;
            } else {
              row.originReceiveMoneyAmount = resetNum;
            }
            returnAmountProps.map((item) => {
              row[item] = 0;
            });
            // 单独补丁
            if (prop == 'originProformaInvoiceAmount') {
              row.localReceiveMoneyAmount = resetNum;
            } else {
              row.localReceiveMoneyAmount = resetNum;
            }
          }
        } else {
          // 当合计金额等于总金额时，最后一条数据其他计算所得金额倒扣
          if (sum == this.firstUnClaimedAmount[prop]) {
            /*  let tableData = this.$refs.table.getTableData().fullData;
          let len = tableData.length;
          let otherIdx = idx + 1;
          returnAmountProps.map(item => {
            let itemAmount = tableData[len-1][item];
            let itemAmountSum = this.$refs.table.getTableData().footerData[0][otherIdx];
            tableData[len-1][item] = this.$cal.calCommon(this.$cal.calCommon(
              this.firstUnClaimedAmount[item], itemAmountSum, '-'), itemAmount, '+', 'amount');
            otherIdx++;
          }); */
            // 更新数据
            this.updateData();
          }
        }
      },
      // 一次认领赋值
      chooseTable(val, row, prop) {
        // 合同
        if (prop == 'salesOrderNo' || prop == 'purchaseOrderNo') {
          row.ladingNo = row.contractNo = null;
          if (val && val.length > 0) {
            row[prop] = val[0].contractNo;
          } else {
            row[prop] = null;
          }
          row.ladingNo = null;
          if (val[0].extendMap.projectInitiationNo) {
            row['projectName'] = val[0].extendMap.projectName;
            row['projectCode'] = val[0].extendMap.projectInitiationNo;
          }
        }
        // 提单号
        if (prop == 'ladingNo') {
          if (val && val.length > 0) {
            row[prop] = val[0].ladingNo;
          } else {
            row[prop] = null;
          }
        }
        // 业务订单
        if (prop == 'contractNo') {
          if (val && val.length > 0) {
            row.contractNo = val[0].orderNo;
          } else {
            row.contractNo = null;
          }
        }
        if (prop == 'projectCode') {
          if (val && val.length > 0) {
            row['projectName'] = val[0].projectName;
            row['projectCode'] = val[0].projectNo;
          } else {
            row['projectName'] = null;
            row['projectCode'] = null;
          }
        }
        if (prop == 'settlementNo') {
          if (val && val.length > 0) {
            row['settlementNo'] = val[0].receivableSettlementNo;
            row['salesOrderNo'] = val[0].contractNo;
          } else {
            row['settlementNo'] = null;
          }
        }
        // 金额类
        if (prop.indexOf('Amount') != -1) {
          row[prop] = val ? val : 0;
          // let idx;
          if (prop == 'originProformaInvoiceAmount') {
            // 形式发票金额
            row.localProformaInvoiceAmount = this.calcLocalAmount(row.originProformaInvoiceAmount);
            let returnAmountProps = [
              'originReceiveMoneyAmount',
              'originDomesticBankDeductFee',
              'originForeignBankDeductFee',
            ];
            returnAmountProps.map((item) => {
              row[item] = this.calcOriginAmount(
                row.originProformaInvoiceAmount,
                this.secondUnClaimAmount.originProformaInvoiceAmount,
                this.secondUnClaimAmount[item]
              );
              row['local' + item.split('origin')[1]] = this.calcLocalAmount(row[item]);
            });
          } else {
            // 收款金额
            row.localReceiveMoneyAmount = this.calcLocalAmount(row.originReceiveMoneyAmount);
            let returnAmountProps = ['originDomesticBankDeductFee', 'originForeignBankDeductFee'];
            returnAmountProps.map((item) => {
              row[item] = this.calcOriginAmount(
                row.originReceiveMoneyAmount,
                this.secondUnClaimAmount.originReceiveMoneyAmount,
                this.secondUnClaimAmount[item]
              );
              row['local' + item.split('origin')[1]] = this.calcLocalAmount(row[item]);
            });
          }
          // 实时合计
          this.updateFooterEvent();
          this.verifyAmount(val, row, prop);
        }
      },
      chooseFirstClaimId(val) {
        // 选择一次认领行项目号
        let item = val.row;
        console.log(item, '======>>');
        if (item.firstClaimId) {
          if (item.firstClaimId != '-1') {
            let tableData = this.$refs.table.getTableData().fullData;
            Object.keys(this.addRowObj).map((it) => {
              if (it.indexOf('Amount') != -1 || it.indexOf('Fee') != -1) {
                let sameFirstSum = 0; //相同一次认领行的合计
                let restNum = 0;
                // 如果存在已有数据，需要进行扣减
                if (tableData[0]) {
                  tableData = tableData.filter((item1) => item1.firstClaimId == item.firstClaimId);
                  tableData.map((item1) => {
                    sameFirstSum = this.$cal.calCommon(sameFirstSum, item1[it], '+');
                  });
                  restNum = this.$cal.calCommon(
                    this.firstClaimNoList.find((i) => i.value == item.firstClaimId)[it],
                    sameFirstSum,
                    '-'
                  );
                }
                item[it] = restNum;
              } else if (it === 'projectCode' || it === 'projectName') {
                item[it] = this[it];
              } else if (it.indexOf('customer') == -1 && it != 'firstClaimId') {
                item[it] = this.firstClaimNoList.find((i) => i.value == item.firstClaimId)[it];
              } else if (it.indexOf('customer') != -1 || it.indexOf('claimDepartment') != -1) {
                item[it] = this.firstClaimNoList.find((i) => i.value == item.firstClaimId)[it];
              }
            });
            this.receiptClaimMode = this.departmentList.find(
              (i) => i.value == item.claimDepartmentNo
            ).receiptClaimMode;
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: '该条一次认领尚未保存，请先保存再二次认领！',
            });
            this.clearRowInfo(val);
            this.receiptClaimMode = null;
          }
        } else {
          this.clearRowInfo(val);
        }
      },
      updateFooterEvent() {
        // 在值发生改变时更新表尾合计
        let xTable = this.$refs.table;
        xTable.updateFooter();
      },
      clearRowInfo(val) {
        Object.keys(this.addRowObj).map((item) => {
          if (item.indexOf('Amount') != -1 || item.indexOf('Fee') != -1) {
            val.row[item] = 0;
          } else if (item.indexOf('customer') == -1 && item.indexOf('project') == -1) {
            val.row[item] = null;
          }
        });
      },
      // 计算原币
      calcOriginAmount(amountRow, totalAmountRow, returnTotalAmount) {
        // 当前行标识金额 * 最终所需返回金额的总额 / 标识金额总额
        let calcAmount1 = this.$cal.calCommon(amountRow, returnTotalAmount, '*');
        let calcAmount2 = this.$cal.calCommon(calcAmount1, totalAmountRow, '/', 'amount');
        return calcAmount2;
      },
      // 计算本币
      calcLocalAmount(originAmount) {
        return this.$cal.calCommon(originAmount, this.formData.exchangeRate, '*', 'amount');
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          return {
            fundCollectionSecondClaimList: [],
            delFundCollectionSecondClaimList: this.del,
          };
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              let param = {
                fundCollectionSecondClaimList: tableData.map((item) => {
                  return {
                    ...item,
                    originReceiveMoneyAmount: +item.originReceiveMoneyAmount,
                  };
                }),
                delFundCollectionSecondClaimList: this.del,
              };
              resolve(param);
            });
          });
        }
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManage.message.${info}`),
          type: type,
        });
      },
      activeRowMethod({ row }) {
        this.secondUnClaimAmount = this.filterTotalAmount(row.firstClaimId);
        return !this.isDisabled;
      },
      formatterReceivedType({ cellValue }) {
        let options = this.$baseRequest.getDictListMapByType('receivedType');
        options.push({ label: '供应商保证金', value: 'RT18' });
        if (!options) return cellValue;
        let tempValue = options.find((it) => it.value == cellValue);
        if (tempValue != null) {
          return tempValue.label;
        } else {
          return cellValue || '';
        }
      },
    },
  };
</script>
